import { colors, typography } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import styled from 'styled-components';

export const SectionWrapperStyled = styled.section`
  width: 100%;
  box-sizing: border-box;
`;

export const SectionTitleStyled = styled(SectionTitle)`
  margin-bottom: 1rem;
`;

export const ProductLinesGridStyled = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(21rem, 1fr));
  gap: 3rem;
  justify-content: center;
  margin: 0;
  padding: 2rem 0 0;
`;

export const ProductLineCardStyled = styled.li`
  display: flex;
  flex-direction: column;
  background-color: ${colors.neutral.white};
  border-radius: 6px;
  color: ${colors.neutral[900]};
  padding: 1rem 2rem 1.6rem;
  min-height: 14rem;
  box-sizing: border-box;
`;

export const ProductLineTitleSlotStyled = styled.div`
  margin-bottom: 0.8rem;
  padding-bottom: 1rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const StatListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const StatRowStyled = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

export const StatLabelStyled = styled.span`
  ${typography.regular[16]}
  color: ${colors.neutral[700]};
`;

export const StatValueStyled = styled.span`
  ${typography.bold[16]}
  color: ${colors.neutral[900]};
`;
